module.exports = __webpack_public_path__ + "img/图层 25.014e7e6c.png";